export default "__VITE_ASSET__BOMZ2woL__"